import { getCurrentInstance, inject } from 'vue';
import { ApiClient, type ApiClientOptions } from './api-client';
import { API_SYMBOL } from './shared';
import type { IApiClient } from './types';

let apiClient: IApiClient | null = null;

export function createApiClient(options: ApiClientOptions): IApiClient {
  if (apiClient) {
    throw new Error('Api client was already initialized');
  }

  apiClient = new ApiClient(options);

  return apiClient;
}

export function useApiClient(): IApiClient {
  const componentInstance = getCurrentInstance();

  if (componentInstance) {
    const api = inject(API_SYMBOL);
    if (!api) {
      throw new Error('Api client is not initialized. Call app.use(apiClientPlugin) first.');
    }
    return api;
  }

  if (!apiClient) {
    throw new Error('Api client is not initialized. Call initApiClient(...) first.');
  }

  return apiClient;
}

export type { AuthState } from './types';
